/**
 * Entitlement catalog (C2). Maps the capabilities this dashboard cares about to
 * matchers over Graph service-plan names.
 *
 * WHY NAME-MATCH, NOT GUIDs: Microsoft's servicePlanId GUIDs and SKU part numbers
 * drift and are easy to get subtly wrong. Matching on servicePlanName substrings is
 * more stable and, crucially, editable in one place. Anything we cannot positively
 * match resolves to `indeterminate` rather than a fabricated answer.
 *
 * Verify against `GET /subscribedSkus` on a real tenant and tune patterns here.
 */
export interface CapabilityDef {
  readonly id: string;
  readonly label: string;
  readonly description: string;
  /** Case-insensitive substrings; a plan matches if ANY pattern is contained. */
  readonly planNamePatterns: readonly string[];
}

export const ENTITLEMENT_CATALOG: readonly CapabilityDef[] = [
  {
    id: 'copilot_m365',
    label: 'Microsoft 365 Copilot',
    description: 'Copilot across Word, Excel, Outlook, Teams and Microsoft 365 apps.',
    planNamePatterns: ['COPILOT'],
  },
  {
    id: 'agent_365',
    label: 'Agent 365',
    description: 'Licence that gates the Copilot agent inventory (C5).',
    planNamePatterns: ['AGENT_365', 'AGENT365', 'M365_AGENT'],
  },
  {
    id: 'purview_ip',
    label: 'Information Protection (Purview)',
    description: 'Sensitivity labels and policy needed for the oversharing scan (C4).',
    planNamePatterns: ['INFORMATION_PROTECTION', 'MIP_S', 'PURVIEW', 'RMS_S_ENTERPRISE'],
  },
  {
    id: 'entra_id_p2',
    label: 'Microsoft Entra ID P2',
    description: 'Identity Protection / PIM signals used across posture views.',
    planNamePatterns: ['AAD_PREMIUM_P2', 'ENTRA_ID_P2'],
  },
] as const;
